import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {colors} from 'theme';

export const HeaderControls = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
`;

export const SearchWrapper = styled.div`
    width: min(100%, 320px);
`;

export const CreateStorageButton = styled(Button)`
    width: auto;
    color: ${colors.white};

    > span {
        padding: 0 16px;
    }
`;

export const StorageNameButton = styled.button`
    padding: 0;
    border: 0;
    background: transparent;
    color: ${colors.brandPrimary};
    font: inherit;
    text-align: left;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`;
